<template>
  <div>
    <div v-if="isContentLoading">Загрузка...</div>
    <div v-else>
      <button class="btn btn-info" @click="downloadReport()" :disabled="isLoading">Выгрузить результат</button>
      <button class="btn btn-success align-items-center justify-content-end" :disabled="isLoading" @click="showUploadModal = true">Загрузить xlsx файл</button>
      <b-table-simple bordered="">
        <b-thead head-variant="light">
          <b-tr>
            <b-th>#</b-th>
            <b-th>Населенный пункт</b-th>
            <b-th>Тип населенного пункта</b-th>
            <b-th>Сумма</b-th>
            <b-th>Год</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <template v-for="(document, index) in kindergartenSpecialStandardList" :key="index">
            <b-tr>
              <b-td>{{ index+1 }}</b-td>
              <b-td>{{ document.kato.nameRu }} ({{ document.kato.code }})</b-td>
              <b-td>{{ document.localityType.name }} ({{ document.localityType.code }})</b-td>
              <b-td>{{ document.price }}</b-td>
              <b-td>{{ document.year }}</b-td>
            </b-tr>
          </template>
        </b-tbody>
      </b-table-simple>
    </div>

    <div v-if="showUploadModal" class="modal">
      <div class="modal-content">
        <h4>Выберите .xlsx файл для загрузки Номера платежей</h4>
        <form @submit.prevent="handleUploadSubmit">
          <div class="form-group">
            <label for="timesheetFile" class="form-label">
              Выберите .xlsx файл
            </label>
            <input type="file" id="timesheetFile" class="form-control" required accept=".xlsx" @change="handleFileUpload">
          </div>
          <div class="form-group">
            <button type="submit" class="submit-btn" :disable="isLoading">
              {{ isLoading ? 'Загружается...' : 'Загрузить' }}
            </button>
          </div>
        </form>
        <button class="close-modal-btn" @click="showUploadModal = false">Закрыть</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import {defineComponent, onMounted, ref} from "vue";
import Multiselect from "vue-multiselect";
import {KindergartenSpecialStandard} from "@/types/kindergarten";
import {
  findAllKindergartenSpecialStandard,
  uploadKindergartenSpecialStandardXlsx
} from "@/services/kindergartenSpecialStandard";
import {downloadKindergartenSpecialStandardReport} from "@/services/reportService";
import {ElMessage} from "element-plus";

export default defineComponent({
  name: "KindergartenSpecialStandardView",
  components: {Multiselect},
  setup: function () {
    const uploadedFile = ref<any>();
    const isContentLoading = ref(false);
    const isLoading = ref(false);
    const kindergartenSpecialStandardList = ref<KindergartenSpecialStandard[]>([]);
    const showUploadModal = ref(false);

    const fetchKindergartenSpecialStandardList = async () => {
      isContentLoading.value = true;
      kindergartenSpecialStandardList.value = await findAllKindergartenSpecialStandard();
      isContentLoading.value = false;
    }

    const downloadReport = async () => {
      try {
        isLoading.value = true;
        await downloadKindergartenSpecialStandardReport();
        isLoading.value = false;
      } catch (error) {
        isLoading.value = false;
        console.error(error);
      }
    }

    const handleFileUpload = (event: any) => {
      uploadedFile.value = event.target.files[0];
    }

    const handleUploadSubmit = () => {
      try {
        if (uploadedFile.value) {
          isLoading.value = true;
          const formData = new FormData();
          formData.append('file', uploadedFile.value);
          uploadKindergartenSpecialStandardXlsx(formData).then(() => {
            isLoading.value = false;
            window.location.reload();
          }).catch((error) => {
            if (error.status === 400) {
              ElMessage({
                message: error.response.data,
                type: 'error',
                duration: 0,
                showClose: true,
              });
            }
            isLoading.value = false;
          })
        }
      } catch(error) {
        isLoading.value = false;
        console.error(error);
      }
    }

    onMounted(() => {
      fetchKindergartenSpecialStandardList();
    });

    return {
      isContentLoading,
      isLoading,
      kindergartenSpecialStandardList,
      showUploadModal,
      downloadReport,
      handleFileUpload,
      handleUploadSubmit,
    }
  }
});

</script>

<style scoped>

.success {
  background-color: green !important;
}

.default {
  transition: background-color 1s cubic-bezier(0, 1, 1, 0);
}

.open-modal-btn {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.open-modal-btn:hover {
  background-color: #45a049;
}

.modal {
  display: block;
  position: fixed;
  z-index: 5;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 400px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

h4 {
  text-align: center;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.submit-btn {
  width: 100%;
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.submit-btn:hover {
  background-color: #45a049;
}

.close-modal-btn {
  margin-top: 10px;
  width: 100%;
  padding: 10px;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.close-modal-btn:hover {
  background-color: #e31b0c;
}
</style>